<template>
    <div class="card service-levels-table">
        <div class="card-content scrollable sticky" :style="{ height: `${scrollableHeight}px` }">
            <b-table :data="serviceLevels" hovered bordered striped :loading="loading">
                <template slot-scope="props">
                    <b-table-column field="priority" label="Priority" :class="props.row.archivedAt != null ? 'archived' :''">{{props.row.priorityCode ? props.row.priorityCode.name : 'N/A' }}</b-table-column>
                    <b-table-column field="name" label="Firm" :class="props.row.archivedAt != null ? 'archived' :''">{{props.row.firmAssociation && props.row.firmAssociation.firm ? props.row.firmAssociation.firm.name : 'N/A' }}</b-table-column>
                    <b-table-column field="hoursToStart" label="Hours to Start" :class="props.row.archivedAt != null ? 'archived' :''">{{props.row.hoursToStart}}</b-table-column>
                    <b-table-column field="hourstToFinish" label="Hours to Finish" :class="props.row.archivedAt != null ? 'archived' :''">{{props.row.hoursToFinish}}</b-table-column>
                    <b-table-column field="archived_at" label="Actions" width="40">
                      <b-button
                        v-if="props.row.archivedAt == null"
                        @click.prevent="archive(props.row.id)"
                        size="is-small"
                        ref="test"
                      >ARCHIVED</b-button>
                      <b-button
                        @click.prevent="restore(props.row.id)"
                        size="is-small"
                        v-else
                      >RESTORE</b-button>
                    </b-table-column>
                </template>
                <template slot="empty">
                    <div class="content has-text-grey has-text-centered">
                        <p>No service levels found.</p>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { ServiceLevelService } from "@/services/serviceLevel.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";

export default {
  props: {
    height: {
      type: Number,
      default: 500
    },
    serviceLevels: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    serviceLevelService: ServiceLevelService,
    submit: false,
    data: []
  }),
  computed: {
    scrollableHeight() {
      return this.height;
    }
  },
  methods: {
    async archive(id) {
      try {
        this.$parent.fetching = true;
        const params = {includes: "firmAssociation.firm,priorityCode,region"}
        const response = await this.serviceLevelService.archive(id, params);
        const serviceLevel = JsonDenormalizer.denormalize(response);
        this.$parent.archivedOrRestored(serviceLevel);
        this.$parent.fetching = false;
				
      } catch (err) {
        this.$parent.fetching = false;
      }
    },
    async restore(id) {
      try {
        this.$parent.fetching = true;
        const params = {includes: "firmAssociation.firm,priorityCode,region"}
        const response = await this.serviceLevelService.restore(id, params);
        const serviceLevel = JsonDenormalizer.denormalize(response);
				this.$parent.archivedOrRestored(serviceLevel);
        this.$parent.fetching = false;
      } catch (err) {
        this.$parent.fetching = false;
      }
    }
  }
};
</script>

<style lang="scss">

    .service-levels-table {
        .scrollable {
            padding: 0;
        }
        .sticky {
            th {
                position: sticky;
                top: 0;
                background: gainsboro;
                z-index: 1;
            }
        }
        .table {
            border: none !important;
            td.archived{
                  text-decoration: line-through;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/pages/ServiceLevels/list/partials/table.vue